export default __webpack_public_path__ + "static/benefitSection1Bg-681e5ff4a3f7696bdc137a706af40075.png";